const SCROLL_PADDING = 100

/**
 * Scrolls the container to make the element visible
 * @param scrollIntoViewElement The element to scroll into view.
 * @param scrollContainerRef The ref of the scroll container.
 * @param forceScroll If true, forces scrolling even if the element is already fully visible.
 * @param immediately If true, scrolls immediately without waiting for any animations.
 * @param onAfterScroll Optional callback to be called after scrolling.
 * @returns
 */
function scroll({
  scrollIntoViewElement,
  scrollContainerRef,
  forceScroll = false,
  onAfterScroll,
  immediately = false,
}: {
  scrollIntoViewElement: Element
  scrollContainerRef: HTMLDivElement
  forceScroll?: boolean
  immediately?: boolean
  onAfterScroll?: () => void
}) {
  const scrollContainer = scrollContainerRef

  if (!scrollContainer) return

  if (immediately) {
    goScroll()

    return
  }

  // Wait for the section expansion animation to finish before defining the scroll top value and scrolling
  // The ms value is based on the animation duration and should be a bit longer to ensure the animation is completed
  setTimeout(goScroll, 500)

  function goScroll() {
    const scrollContainerTop = scrollContainer!.getBoundingClientRect().top
    const scrollContainerBottom = scrollContainer!.getBoundingClientRect().bottom
    const elTop = scrollIntoViewElement.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top

    const elBottom = scrollIntoViewElement.getBoundingClientRect().bottom

    const isElementsFullySeen = elBottom <= scrollContainerBottom && elTop >= scrollContainerTop

    if (isElementsFullySeen && !forceScroll) return

    scrollContainer?.scrollTo({
      top: elTop + scrollContainer.scrollTop - SCROLL_PADDING,
      behavior: 'smooth',
    })

    onAfterScroll?.()
  }
}

export default scroll
